import { defineMessages } from 'react-intl';

const translations = {
  clearText: {
    id: 'components.autocomplete.clearText',
    defaultMessage: 'Clear',
    description: 'label of the clear button',
  },
  loadingText: {
    id: 'components.autocomplete.loadingText',
    defaultMessage: 'Loading...',
    description: 'text to display when in a loading state',
  },
  noOptionsText: {
    id: 'components.autocomplete.noOptionsText',
    defaultMessage: 'No options',
    description: 'text to display when there are no options',
  },
  openText: {
    id: 'components.autocomplete.openText',
    defaultMessage: 'Open',
    description: 'label of the open popup button',
  },
};

export default defineMessages(translations);
